<section class="container py-2 py-lg-4">
  <div class="row">
    <div class="col-md-10 col-lg-8 col-xl-6">
      <h2 *scText="heading()" class="text-section__heading"></h2>
      <div *wlGenericRichText="richText()" class="text-section__richText"></div>
      <ng-content select="[call-to-action-button]" />
      <ng-content select="[app-store-buttons]" />
    </div>
  </div>
</section>
